<template>
  <div class="page__container">
    <div
        class="page__content"
    >
      <template v-if="!getUserStatus.is_young_scientist">
        <div class="page__subtitle">
          Уважаемый пользователь, благодарим вас за проявленный интерес к нашему проекту.<br/>
          Обращаем ваше внимание, что карта проекта предназначена для участников в возрасте до 35 лет включительно.<br/>
          Мы ценим ваше участие и благодарим за понимание.
        </div>
      </template>
      <template v-else-if="getUserStatus.can_update && getUserStatus.is_expired && !getUserStatus.is_application_exists">
        <div class="page__subtitle">
          Для продления карты актуализируйте ваши личные данные.
        </div>
        <div class="btn__next ma-1" @click="goToNextPage()">
        <span class="btn__next_text">
          Актуализировать
        </span>
        </div>
        <div class="btn__next ma-1" @click="goToNextPage(true)">
        <span class="btn__next_text">
          Сменить категорию
        </span>
        </div>
      </template>
      <template v-else-if="!getUserStatus.can_update && getUserStatus.is_expired && !getUserStatus.is_application_exists">
        <div class="page__subtitle">
          Уважаемый пользователь, срок действия вашей карты истек.<br/>
          Для продления карты отправьте заявку с актуальной категорией пользователя.
        </div>
        <div class="btn__next" @click="goToNextPage()">
        <span class="btn__next_text">
          Отправить заявку
        </span>
        </div>
      </template>
      <template v-else-if="getUserStatus.is_application_exists">
        <div class="page__subtitle">
          Ваша заявка на продление на рассмотрении.
        </div>
      </template>
      <template v-else>
        <div class="page__subtitle">
          Пожалуйста, скорректируйте информацию, ранее указанную при регистрации.
        </div>
        <div class="btn__next" @click="goToNextPage()">
        <span class="btn__next_text">
          Внести изменения
        </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"

export default defineComponent({
  name: "PageNotValid",
  computed: {
    names () {
      return names
    },
    pa_names () {
      return pa_names
    },
    ...mapGetters({
      getUserStatus: 'auth/getUserStatus',
      getInfo: 'personal_account/users/getUserInfo'
    })
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'personal_account/users/loadUserInfo',
    }),
    goToNextPage (re_zero = false) {
      if (this.getUserStatus.can_update && this.getUserStatus.is_expired) {
        if (re_zero) {
          this.$router.push({ name: names.REGISTRATION.PAGE })
        } else {
          if (this.getInfo?.type === 'postgraduate' || this.getInfo?.type === 'science') {
            this.$router.push({ name: names.UPDATE_INDIVIDUAL.PAGE, query: { type: this.getInfo.type } })
          } else {
            this.$router.push({ name: names.UPDATE.PAGE })
          }
        }
      } else if (!this.getUserStatus.can_update && this.getUserStatus.is_expired) {
        this.$router.push({ name: names.REGISTRATION.PAGE })
      } else if (this.getUserStatus.is_not_valid) {
        this.$router.push({ name: names.REGISTRATION.PAGE })
      } else {
        this.$router.push({ name: pa_names.MAIN })
      }
    },
    loadData (url = undefined) {
      this.loadUserInfo({
        url: url,
        finalizer: () => {},
        catcher: () => {}
      })
    },
  },
  created () {
    if (this.getInfo === null) {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.page__container {
  width: 100%;
  padding: 50px;
  margin: 0 auto;
}

.page__content {
  padding: 30px;
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
}

.page__subtitle {
  padding-top: 40px;
  margin-bottom: 40px;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 400px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-width: 1920px) {
  .btn__next {
    height: 60px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .page__container {
    width: 100%;
    padding: 20px;
    margin: 0 auto;
  }

  .page__content {
    padding: 20px;
    text-align: center;
    border-radius: 5px;
    width: 100%;
    background-color: white;
  }

  .btn__next {
    width: 300px;
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
